import Component from '../abstracts/Component';


/**
 Login component
 */
export default class LoginComponentChina extends Component {

  get SELECTORS() {
    return {
      form: '.login-form',
      usernameToCopy: '#username',
      usernameToApply: '#j_username',
      phonePrefix: '#phonePrefix',
      loginButton: '.login-form #loginBtn',
    };
  }

  constructor() {
    super();
  }

  render() {
    const {form,usernameToCopy,usernameToApply,phonePrefix,loginButton} = this.SELECTORS;

    $(document).on('click',loginButton,function () {
      const $closestForm = $(this).closest(form);
      const $usernameToCopy = $(usernameToCopy, $closestForm);
      const $usernameToApply = $(usernameToApply, $closestForm);
      const $prefix = $(phonePrefix, $closestForm);
      const prefix = $prefix.val() || '';

      $usernameToApply.val("" + prefix + "" + ($usernameToCopy.val() || '').trim());
    })
  }

}
